module.exports = __webpack_public_path__ + "static/media/dien-toan.d8ac87a0.png";